import React, { memo } from "react";
import { AgentDetailSection } from "../../../../../../agentDetail.model";
import { useAgentsStore } from "../../../../../../store/agents.store";
import { selectAgentDetailSaving } from "../../../../../../store/agentDetail/agentDetailSelectors";
import { AGENT_DETAIL_TABS } from "../../constants/agentDetailTabs";
import { HIDE_FOOTER_TABS, RIGHT_SECTION_TABS } from "./rightSection.constants";
import { Footer } from "./components/footer/footer.index";
import styles from "./rightSection.module.css";

interface RightSectionProps {
    activeTab: AgentDetailSection;
}

export const RightSection = memo(({ activeTab }: RightSectionProps) => {
    const isSaving = useAgentsStore(selectAgentDetailSaving);
    const Panel = RIGHT_SECTION_TABS[activeTab];
    const headerTitle = AGENT_DETAIL_TABS.find((tab) => tab.key === activeTab)?.label ?? "";

    return (
        <div className={styles.container}>
            <h2 className={styles.headerTitle}>{headerTitle}</h2>
            <div
                className={`${styles.panelContainer} ${isSaving ? styles.panelSaving : ""}`}
                aria-busy={isSaving}
            >
                <Panel />
            </div>
            {!HIDE_FOOTER_TABS.includes(activeTab) && <Footer saveScope={activeTab} />}
        </div>
    );
});
